import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 213.02 121.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 121.5h122.21L143.98 0 0 121.5Z",
      style: {"fill":"#3d4194","fill-rule":"evenodd"}
    }, null, -1),
    _createElementVNode("path", {
      d: "m127.16 53.07 1.01-39.73-3.35 2.82-.93 37.25-4.49 16.53h-.02.02l-7.71-14.1-4.11-25.12-2.9 2.44 3.63 22.68v17.74l.1-.03c-.06.03-.12.04-.18.07l.08-.04-10.64-12.47-9.15-14.32-2.46 2.08 8.75 13.69 4.16 15.93.11-.06c-.08.05-.15.1-.22.15l.11-.09-14.2-9.6-8.99-11.34-2.41 2.03 8.9 11.24 8.01 14.31-16.33-6.53L62 69.17l-2.41 2.04 12.31 9.72 11.29 11.92.11-.11c-.06.07-.11.14-.17.22l.06-.11-17.71-3.05-18.34-8.08-2.57 2.17 19.38 8.54 13.52 9.51.09-.16c-.05.12-.11.23-.17.34l.07-.19-17.42-1.21-26.83-7.26-2.79 2.35 28.59 7.73 14.75 7.91-17.27 2.04-44.04-2.51-3.31 2.8 46.9 2.67L72 120.9l60.07-49.76-4.91-18.09Z",
      style: {"fill":"#f6b83a","fill-rule":"evenodd"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M69.04 121.5h122.2L213.02 0 69.04 121.5Z",
      style: {"fill-rule":"evenodd","fill":"#ed373b"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "PR-logo"}) } }